import { db } from '../components/Dexie';
import { log } from './loggingService';

/**
 * Sincronizza i menu con l'API remota.
 * @param {boolean} force - Se true, cancella i dati locali e forza un sync completo.
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const syncTechyShopMenu = async (force = true) => {
  try {
    if (force) {
      log("Reset menu techyshop locali in corso...", 'INFO');
      await db.techyshop_menu.clear();
    }

    log("Avvio download menu dal server...", 'INFO');

    const response = await fetch('https://deadapi.techysumo.it/techyshop/searchMenu', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Utilizziamo la stessa chiave API degli altri servizi
        'Authorization': process.env.REACT_APP_API_KEY || '12345',
      },
      body: JSON.stringify({})
    });

    const result = await response.json();

    if (result.result && Array.isArray(result.details)) {
      const normalizedMenus = result.details.map(m => ({
        ...m,
        id: isNaN(parseInt(m.id)) ? m.id : parseInt(m.id),
        enable: (m.enable == 1 || m.enable === true || String(m.enable).toLowerCase() === 'true') ? 1 : 0
      }));

      await db.techyshop_menu.bulkPut(normalizedMenus);
      log(`Sincronizzati ${normalizedMenus.length} menu.`, 'INFO');

      return { success: true, message: `Sincronizzati ${normalizedMenus.length} menu con successo!` };
    } else {
      throw new Error(result.text || "Errore durante il download dei menu.");
    }
  } catch (error) {
    log("Errore durante la sincronizzazione dei menu:", 'ERROR', error);
    return { success: false, message: `Errore: ${error.message}` };
  }
};

/**
 * Sincronizza le voci menu con l'API remota.
 * @param {number|string} menuId - ID del menu (opzionale)
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const syncTechyShopVociMenu = async (menuId = null) => {
  try {
    log("Avvio download voci menu dal server...", 'INFO');

    const filters = menuId ? [{ field: 'menu_id', value: menuId }] : [];

    const response = await fetch('https://deadapi.techysumo.it/techyshop/searchVociMenu', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_KEY || '12345',
      },
      body: JSON.stringify({ filters })
    });

    const result = await response.json();

    if (result.result && Array.isArray(result.details)) {
      if (menuId) {
        // Se stiamo filtrando per menuId, cancelliamo solo quelle voci
        await db.techyshop_voci_menu.where('menu_id').equals(menuId).delete();
      } else {
        await db.techyshop_voci_menu.clear();
      }

      const normalizedVoci = result.details.map(v => ({
        ...v,
        id: isNaN(parseInt(v.id)) ? v.id : parseInt(v.id),
        menu_id: isNaN(parseInt(v.menu_id)) ? v.menu_id : parseInt(v.menu_id),
        ordinamento: isNaN(parseInt(v.ordinamento)) ? v.ordinamento : parseInt(v.ordinamento),
        target_blank: (v.target_blank == 1 || v.target_blank === true || String(v.target_blank).toLowerCase() === 'true') ? 1 : 0,
        visibile: (v.visibile == 1 || v.visibile === true || String(v.visibile).toLowerCase() === 'true' || v.visibile === undefined) ? 1 : 0
      }));

      await db.techyshop_voci_menu.bulkPut(normalizedVoci);
      log(`Sincronizzate ${normalizedVoci.length} voci menu.`, 'INFO');

      return { success: true, message: `Sincronizzate ${normalizedVoci.length} voci menu con successo!` };
    } else {
      throw new Error(result.text || "Errore durante il download delle voci menu.");
    }
  } catch (error) {
    log("Errore durante la sincronizzazione delle voci menu:", 'ERROR', error);
    return { success: false, message: `Errore: ${error.message}` };
  }
};
